
(function () {
  'use strict';

  function buildVariantMediaSet(allVariants) {
    var ids = new Set();
    allVariants.forEach(function (v) {
      if (v.featured_media) ids.add(String(v.featured_media.id));
    });
    return ids;
  }

  function resetCarousel(sliderEl) {
    if (!sliderEl || !sliderEl.offsetParent) return;
    var track = sliderEl.querySelector('.slider') || sliderEl;
    track.style.scrollSnapType = 'none';
    track.scrollLeft = 0;
    track.style.removeProperty('scroll-snap-type');
  }

  function prependToGrid(sliderEl, item) {
    if (!sliderEl || !item || !sliderEl.offsetParent) return;
    var grid = sliderEl.querySelector('.slider__grid')
            || sliderEl.querySelector('.slider')
            || sliderEl;
    grid.prepend(item);
  }

  function refreshCarousel(sliderEl) {
    if (!sliderEl || !sliderEl.offsetParent) return;
    if (typeof sliderEl.refresh === 'function') {
      sliderEl.refresh();
    }
  }

  function izKeepOrder(product, variant) {
    if (!product || !variant) return false;
    var first = product.media && product.media[0];
    var alt = first && first.alt ? String(first.alt).toLowerCase() : '';
    if (alt.indexOf(', styled,') === -1) return false;
    var t = String(variant.title || '').toLowerCase();
    return t.indexOf('yellow') !== -1;
  }

  function applyFilter(gallery, currentId, variantIds, keepOrder) {
    if (!gallery || variantIds.size === 0) return;
    var section = gallery.closest('.shopify-section');

    
    var collageParent = gallery.querySelector('.product-media-collage');
    if (collageParent && collageParent.offsetParent) {
      var activeCollageItem = null;
      collageParent.querySelectorAll('.product-media-collage__item[data-media-id]')
        .forEach(function (item) {
          var id = item.dataset.mediaId;
          if (!id) return;
          item.hidden = variantIds.has(id) && id !== currentId;
          if (id === currentId) activeCollageItem = item;
        });
      if (activeCollageItem && !keepOrder) collageParent.prepend(activeCollageItem);
    }

    
    var mainSlider = gallery.querySelector('.main-image carousel-slider');
    var activeMainItem = null;
    gallery.querySelectorAll('.main-image .slider__item[data-media-id]')
      .forEach(function (item) {
        var id = item.dataset.mediaId;
        if (!id) return;
        item.hidden = variantIds.has(id) && id !== currentId;
        if (id === currentId) activeMainItem = item;
      });
    if (mainSlider) {
      resetCarousel(mainSlider);              
      if (!keepOrder) prependToGrid(mainSlider, activeMainItem); 
      refreshCarousel(mainSlider);            
    }

    
    var thumbItems = gallery.querySelectorAll('.thumbnails .slider__item[data-media-id]');
    var activeThumbItem = null;
    thumbItems.forEach(function (item) {
      var id = item.dataset.mediaId;
      if (!id) return;
      item.hidden = variantIds.has(id) && id !== currentId;
      if (id === currentId) activeThumbItem = item;
    });
    if (thumbItems.length > 0 && activeThumbItem) {
      var thumbSlider = thumbItems[0].closest('carousel-slider');
      if (thumbSlider) {
        resetCarousel(thumbSlider);
        if (!keepOrder) prependToGrid(thumbSlider, activeThumbItem);
        refreshCarousel(thumbSlider);
      }
    }

    
    if (section) {
      var viewer = section.querySelector('gallery-viewer');
      if (viewer) {
        viewer.querySelectorAll('.gallery-viewer__thumb[data-media-id]')
          .forEach(function (item) {
            var id = item.dataset.mediaId;
            if (!id) return;
            item.hidden = variantIds.has(id) && id !== currentId;
          });
      }
    }
  }

  function getVariantIdsFromSection(section) {
    var scriptEl = section && section.querySelector('[data-product-json]');
    if (!scriptEl) return null;
    var product;
    try { product = JSON.parse(scriptEl.textContent); } catch (e) { return null; }
    var allVariants = product && product.variants;
    if (!allVariants || !allVariants.length) return null;
    var ids = buildVariantMediaSet(allVariants);
    return ids.size > 0 ? ids : null;
  }

  document.addEventListener('on:variant:change', function (evt) {
    var detail = evt.detail;
    if (!detail) return;
    var section = (detail.form && detail.form.closest('.shopify-section'))
                  || (evt.target && evt.target.closest('.shopify-section'));

    
    
    
    if (!section) {
      var allQbInners = document.querySelectorAll('.quickbuy-container .inner');
      for (var k = 0; k < allQbInners.length; k++) {
        var qbCandidate = allQbInners[k];
        if (
          (detail.form && qbCandidate.contains(detail.form)) ||
          (evt.target && qbCandidate.contains(evt.target))
        ) {
          section = qbCandidate;
          break;
        }
      }
    }

    if (!section) return;
    var gallery = section.querySelector('media-gallery');
    if (!gallery) return;
    var variantIds = getVariantIdsFromSection(section);
    if (!variantIds) return;
    var currentId = detail.variant && detail.variant.featured_media
      ? String(detail.variant.featured_media.id) : null;
    var izProduct = null;
    try { izProduct = JSON.parse(section.querySelector('[data-product-json]').textContent); } catch (e) {}
    applyFilter(gallery, currentId, variantIds, izKeepOrder(izProduct, detail.variant));
  }, true);

  document.addEventListener('on:quickbuy:after-open', function (evt) {
    var qbInner = (evt.target && evt.target.querySelector)
      ? evt.target.querySelector('.inner')
      : document.querySelector('.quickbuy-container .inner');
    if (!qbInner) return;
    var scriptEl = qbInner.querySelector('[data-product-json]');
    if (!scriptEl) return;
    var product;
    try { product = JSON.parse(scriptEl.textContent); } catch (e) { return; }
    var allVariants = product && product.variants;
    if (!allVariants || !allVariants.length) return;
    var variantIds = buildVariantMediaSet(allVariants);
    if (variantIds.size === 0) return;
    var gallery = qbInner.querySelector('media-gallery');
    if (!gallery) return;
    
    var idInput = qbInner.querySelector('form input[name="id"]');
    var selectedId = idInput ? idInput.value : null;
    var selected;
    if (selectedId) selected = allVariants.find(function (v) { return String(v.id) === selectedId; });
    if (!selected) selected = allVariants.find(function (v) { return v.available; }) || allVariants[0];
    var currentId = selected && selected.featured_media ? String(selected.featured_media.id) : null;
    var keep = izKeepOrder(product, selected);
    setTimeout(function () { applyFilter(gallery, currentId, variantIds, keep); }, 300);
  });

  function initOnLoad() {
    document.querySelectorAll('[data-product-json]').forEach(function (scriptEl) {
      var product;
      try { product = JSON.parse(scriptEl.textContent); } catch (e) { return; }
      var allVariants = product && product.variants;
      if (!allVariants || !allVariants.length) return;
      var variantIds = buildVariantMediaSet(allVariants);
      if (variantIds.size === 0) return;
      var section = scriptEl.closest('.shopify-section');
      var gallery = section && section.querySelector('media-gallery');
      if (!gallery) return;
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariantId = urlParams.get('variant');
      var selected;
      if (urlVariantId) selected = allVariants.find(function (v) { return String(v.id) === urlVariantId; });
      if (!selected) selected = allVariants.find(function (v) { return v.available; }) || allVariants[0];
      var currentId = selected && selected.featured_media ? String(selected.featured_media.id) : null;
      var keep = izKeepOrder(product, selected);
      setTimeout(function () { applyFilter(gallery, currentId, variantIds, keep); }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnLoad);
  } else {
    initOnLoad();
  }
}());

/* Instafeed: show each video's thumbnail before it plays (videos ship with preload=none and only data-poster) */
(function () {
  function izInstaPosters() {
    var vids = document.querySelectorAll('#insta-feed video[data-poster]:not([poster])');
    for (var i = 0; i < vids.length; i++) {
      vids[i].setAttribute('poster', vids[i].getAttribute('data-poster'));
      vids[i].setAttribute('preload', 'metadata');
    }
    return document.getElementById('insta-feed');
  }
  function izInstaInit() {
    var feed = izInstaPosters();
    var target = feed || document.body;
    var obs = new MutationObserver(function () { izInstaPosters(); });
    obs.observe(target, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', izInstaInit);
  } else {
    izInstaInit();
  }
}());
